<template>
    <BreadCrumb PageTitle="Liste Type d'Acteur" />
    <ListeTypeActeur />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AddModalTypeActeur from "@/components/TypeActeur/AddModalTypeActeur.vue";
import ListeTypeActeur from "@/components/TypeActeur/ListeTypeActeur.vue";


export default defineComponent({
    name: "ListeTypeActeurPage",
    components: {
        BreadCrumb,
        ListeTypeActeur,
    },
});
</script>